export default __webpack_public_path__ + "static/heroHome-018f798490e1415a32501e117971d1e0.jpg";